const goodsReceiptsTypes = {
  GOODS_RECEIPTS_TABLE_STATE_SET: 'GOODS_RECEIPTS/TABLE_STATE_SET',
  GOODS_RECEIPTS_TABLE_STATE_RESET: 'GOODS_RECEIPTS/TABLE_STATE_RESET',
};
export default goodsReceiptsTypes;
